import Loader from "react-loader-spinner";

function OtpAndPin({ handleChange, handleSubmitOtp, isSubmittingOtp }) {
  return (
    <>
      <p className="login-page mb-6">
        Enter the OTP sent to your phone and a new security pin
      </p>
      <form className="mb-6" onSubmit={handleSubmitOtp}>
        <div className="form-group mb-5">
          <label className="form-label" htmlFor="pin">
            OTP
          </label>
          <input
            type="password"
            className="form-control"
            onChange={handleChange}
            name="otp"
            title="Numbers only, e.g. 123456"
            maxLength="6"
            id="otp"
            required
            pattern="[0-9]{6}"
            placeholder="e.g. 123456"
          />
        </div>
        <div className="form-group mb-5">
          <label className="form-label" htmlFor="pin">
            New security pin
          </label>
          <input
            type="password"
            className="form-control"
            onChange={handleChange}
            name="security_pin"
            title="Numbers only, e.g. 1234"
            maxLength="4"
            id="security_pin"
            required
            pattern="[0-9]{4}"
            placeholder="e.g. 1234"
          />
        </div>
        {isSubmittingOtp ? (
          <button className="btn w-100 btn-primary">
            <Loader type="Oval" color="#fff" width={20} height={20} />
          </button>
        ) : (
          <button className="btn w-100 btn-primary" type="submit">
            Next
          </button>
        )}
      </form>
    </>
  );
}

export default OtpAndPin;
